import { useEffect } from 'react';
import Add from '@mui/icons-material/Add';
import DataTable, {
  DataTableWrapper,
  DataTableWrapperActionButton,
  getActionsColConfig,
  useTableQueryParams,
} from 'src/components/DataTable';
import { useModal } from 'src/hooks';
import { useDatasetUnitAction } from 'src/redux/helpers';
import { isModalComplete } from 'src/components/ModalDialog';
import { useUserRoles } from 'src/auth';
import platformVersionsStore, { usePlatformVersionsList } from './redux';
import { PlatformVersionField } from './types';
import PlatformVersionsActions from './components/PlatformVersionsActions';
import AddPlatformVersionModalContainer from './components/AddPlatformVersionModalContainer';

const columns = [
  { id: PlatformVersionField.EdgeComponentName, title: 'Edge Component Name' },
  { id: PlatformVersionField.DockerImage, title: 'Docker Image' },
  { id: PlatformVersionField.Version, title: 'Version' },
  getActionsColConfig(PlatformVersionsActions),
];

function PlatformVersions() {
  const [data, loading] = usePlatformVersionsList();
  const action = useDatasetUnitAction(platformVersionsStore);
  const { isPlatformReader } = useUserRoles();
  const { paging, search, sorting } = useTableQueryParams();
  const [AddDialog, showAddDialog] = useModal(
    AddPlatformVersionModalContainer,
    { onClose: (event, reason) => isModalComplete(reason) && action() }
  );

  useEffect(() => {
    action();
  }, []);

  return (
    <DataTableWrapper
      data-testid="platform-versions-wrapper"
      my={3}
      mb={4}
      title="Approved Edge Version"
      actionsPanel={
        <DataTableWrapperActionButton
          data-testid="add-platform-version-button"
          onClick={showAddDialog}
          startIcon={<Add />}
          disabled={isPlatformReader}
        >
          Add New
        </DataTableWrapperActionButton>
      }
    >
      <DataTable
        data={data}
        columns={columns}
        loading={loading}
        {...paging}
        {...sorting}
      />
      {AddDialog}
    </DataTableWrapper>
  );
}

export default PlatformVersions;
